
export default {
  customertypes: null,
  activecustomertypes: null,
  jobtitles: null,
  activejobtitles: null,
  salutations: null,
  activesalutations: null,
  regions: null,
  activeregions: null,
  mbpbranches: null,
  activembpbranches: null,
  salesexecs: null,
  activesalesexecs: null,
  opportunitystatuses: null,
  activeOpportunityStatuses: null,
  quotestatuses: null,
  activequotestatuses: null,
  activitystatuses: null,
  activeactivitystatuses: null,
  activityTypes: null,
  activeactivitytypes: null,
  remindertypes: null,
  activeremindertypes: null,
  activityresults: null,
  activeactivityresults: null,
  producttypes: null,
  activeproducttypes: null,
  projecttypes: null,
  activeprojecttypes: null,
  lostquotenotes: null,
  activelostquotenotes: null,
  datemodifiers: null,
  users: null,
  activeusers: null,
  citiesTowns: null,
  activeCitiesTowns: null,
  roles: null,
  activeRoles: null,
  favoriteFilters: [],
  jobfunctions: null,
  mbpDepartments: null,
  quotationGrades: null,
  activeQuotationGrades: [],
  userWidgets: null,
  opportunities: [],
  mbpdepts: [],
  contacttypes: [],
  activequotations: [],
  parentcustomernames: [],
  contacts: [],
  activeQuoteTypes: [],
  customernames: [],

  columnsSelection1: null, // for view 1, now 1 is not being used, it was for old customers
  columnsSelection2: null, // for view 2
  columnsSelection3: null, // for view 3
  columnsSelection4: null, // for view 4
  columnsSelection5: null, // for view 5
  columnsSelection6: null, // for view 6, customers is using this
  columnsSelection7: null, // for view 7, myActivities is using this
  columnsSelection8: null, // for view 8, enquiries is using this
  columnsSelection12: null, 
  columnsSelection13: null, // for view 13, tasks is using this
  columnsSelection101: null, 
  columnsSelection102: null, 

  dbViewFields1: null,
  dbViewFields2: null,
  dbViewFields3: null,
  dbViewFields4: null,
  dbViewFields5: null,
  dbViewFields6: null,
  dbViewFields7: null,
  dbViewFields8: null,
  dbViewFields12: null,
  dbViewFields13: null,
  dbViewFields101: null,
  dbViewFields102: null,


  userViewFilters1: null,
  userViewFilters2: null,
  userViewFilters3: null,
  userViewFilters4: null,
  userViewFilters5: null,
  userViewFilters6: null,
  userViewFilters7: null,
  userViewFilters8: null,
  userViewFilters12: null,
  userViewFilters13: null,

  defUserViewFilter1: null,
  defUserViewFilter2: null,
  defUserViewFilter3: null,
  defUserViewFilter4: null,
  defUserViewFilter5: null,
  defUserViewFilter6: null,
  defUserViewFilter7: null,
  defUserViewFilter8: null,
  defUserViewFilter12: null,
  defUserViewFilter13: null
}